import React from 'react';
import styled from 'styled-components';
import Avatar from './Avatar';
import { theme } from '../../styles/theme';

const DemoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
  padding: ${theme.spacing[6]};
  background: ${theme.colors.background};
  border-radius: ${theme.borders.radius.lg};
  border: 1px solid ${theme.colors.border};
`;

const DemoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[4]};
`;

const DemoTitle = styled.h3`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.textPrimary};
  margin: 0;
`;

const DemoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${theme.spacing[4]};
  align-items: center;
`;

const DemoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing[2]};
  padding: ${theme.spacing[4]};
  background: ${theme.colors.backgroundSecondary};
  border-radius: ${theme.borders.radius.md};
  border: 1px solid ${theme.colors.border};
`;

const DemoLabel = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textSecondary};
  text-align: center;
`;

const AvatarDemo: React.FC = () => {
  const demoUsers = [
    { name: 'Eduardo Chamorra', email: 'eduardo@example.com' },
    { name: 'Maria Silva', email: 'maria@example.com' },
    { name: 'João Santos', email: 'joao@example.com' },
    { name: 'Ana Costa', email: 'ana@example.com' },
    { name: 'Pedro Oliveira', email: 'pedro@example.com' },
    { name: 'Carla Ferreira', email: 'carla@example.com' },
    { name: 'Rafael Lima', email: 'rafael@example.com' },
    { name: 'Julia Rodrigues', email: 'julia@example.com' },
  ];

  return (
    <DemoContainer>
      <DemoTitle>🎨 Avatar com Logo Loopra - Demo</DemoTitle>
      <p style={{ color: theme.colors.textSecondary, margin: 0, textAlign: 'center' }}>
        Cada usuário tem uma cor única baseada no nome/email, mas todos usam a logo do Loopra!
      </p>
      
      <DemoSection>
        <DemoTitle>Tamanhos Disponíveis</DemoTitle>
        <DemoGrid>
          <DemoItem>
            <Avatar name="Eduardo Chamorra" size="xs" />
            <DemoLabel>XS (24px)</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar name="Eduardo Chamorra" size="sm" />
            <DemoLabel>SM (32px)</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar name="Eduardo Chamorra" size="md" />
            <DemoLabel>MD (48px)</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar name="Eduardo Chamorra" size="lg" />
            <DemoLabel>LG (64px)</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar name="Eduardo Chamorra" size="xl" />
            <DemoLabel>XL (96px)</DemoLabel>
          </DemoItem>
        </DemoGrid>
      </DemoSection>

      <DemoSection>
        <DemoTitle>Logo Loopra com Cores Únicas por Usuário</DemoTitle>
        <DemoGrid>
          {demoUsers.map((user, index) => (
            <DemoItem key={index}>
              <Avatar name={user.name} size="lg" />
              <DemoLabel>{user.name}</DemoLabel>
            </DemoItem>
          ))}
        </DemoGrid>
      </DemoSection>

      <DemoSection>
        <DemoTitle>Fallback para Email</DemoTitle>
        <DemoGrid>
          <DemoItem>
            <Avatar email="usuario@exemplo.com" size="lg" />
            <DemoLabel>usuario@exemplo.com</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar email="admin@empresa.com" size="lg" />
            <DemoLabel>admin@empresa.com</DemoLabel>
          </DemoItem>
        </DemoGrid>
      </DemoSection>

      <DemoSection>
        <DemoTitle>Foto Personalizada vs Logo Loopra</DemoTitle>
        <DemoGrid>
          <DemoItem>
            <Avatar 
              name="Eduardo Chamorra" 
              email="eduardo@example.com"
              size="lg"
              src="https://via.placeholder.com/96x96/FF6B6B/FFFFFF?text=EC"
              alt="Eduardo Chamorra"
            />
            <DemoLabel>Com foto personalizada</DemoLabel>
          </DemoItem>
          <DemoItem>
            <Avatar 
              name="Maria Silva" 
              email="maria@example.com"
              size="lg"
            />
            <DemoLabel>Logo Loopra com cor única</DemoLabel>
          </DemoItem>
        </DemoGrid>
      </DemoSection>
    </DemoContainer>
  );
};

export default AvatarDemo;
